import { render, staticRenderFns } from "./V2Ukuran.vue?vue&type=template&id=be7a7904&"
import script from "./V2Ukuran.vue?vue&type=script&lang=js&"
export * from "./V2Ukuran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports